import { cn } from '@/lib/utils'
import { StatusPill } from './StatusPill'

// Role pills use the brand palette only — Collectia Blue + Turquoise + Grey,
// no off-brand purple/violet. Privilege reads as a hierarchy: solid blue
// (superadmin) → blue tint (admin) → turquoise tint (operator) → grey (viewer).
// Text is always blue/grey, never turquoise (turquoise text fails AA, §7).
const ROLE_CLASSES: Record<string, string> = {
  superadmin: 'bg-brand-blue text-white',
  admin: 'bg-brand-blue/10 text-text-strong',
  operator: 'bg-brand-turquoise/15 text-text-strong',
  viewer: 'bg-status-neutral-bg text-status-neutral-fg',
}

/** Role pill. `label` is the localized role name (resolved by the caller). */
export function RoleBadge({ role, label }: { role: string; label: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        ROLE_CLASSES[role] ?? ROLE_CLASSES.viewer,
      )}
    >
      {label}
    </span>
  )
}

/** Generic on/off status pill (active/configured vs. not), on the brand families. */
export function StatusBadge({ on, label }: { on: boolean; label: string }) {
  return <StatusPill family={on ? 'success' : 'neutral'}>{label}</StatusPill>
}

/** "Pending" pill (e.g. an invitation not yet accepted) — warning family. */
export function PendingBadge({ label }: { label: string }) {
  return <StatusPill family="warning">{label}</StatusPill>
}
